/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgGarbageOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m5.5 2.375.5-.5h4l.5.5v1.5H13l.5.5v1.75l-.5.5h-.29l-.71 8-.5.5h-7l-.5-.5-.71-8H3l-.5-.5v-1.75l.5-.5h2.5v-1.5Zm1 .5v1h3v-1h-3Zm-3 2.75v-.75h9v.75h-9Zm.75 1 .75 7.5h6l.75-7.5h-7.5Zm1.252 1.251v4.249h1V7.876h-1Zm3.997 4.249V7.876h1v4.249h-1ZM7.5 7.876v4.249h1V7.876h-1Z"
}));

export default SvgGarbageOutline;